var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "sync"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_41_1117",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "var(--fill-0, #D9D9D9)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_41_1117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "sync_2",
    d: "M5.75 12.0692C5.75 12.8506 5.89792 13.6102 6.19375 14.348C6.48942 15.0858 6.9505 15.7672 7.577 16.3922L8.2115 17.027V15.0385C8.2115 14.826 8.28342 14.6478 8.42725 14.504C8.57108 14.3603 8.74925 14.2885 8.96175 14.2885C9.17442 14.2885 9.35258 14.3603 9.49625 14.504C9.63975 14.6478 9.7115 14.826 9.7115 15.0385V18.7693C9.7115 19.0253 9.62492 19.2399 9.45175 19.4132C9.27842 19.5864 9.06375 19.673 8.80775 19.673H5.077C4.8645 19.673 4.68633 19.6011 4.5425 19.4572C4.39883 19.3134 4.327 19.1352 4.327 18.9227C4.327 18.7101 4.39883 18.532 4.5425 18.3885C4.68633 18.2448 4.8645 18.173 5.077 18.173H7.25L6.523 17.477C5.70133 16.7167 5.11708 15.865 4.77025 14.922C4.42342 13.9792 4.25 13.0282 4.25 12.0692C4.25 10.5602 4.63717 9.18592 5.4115 7.94625C6.18583 6.70642 7.22558 5.75125 8.53075 5.08075C8.71275 4.97942 8.90408 4.96792 9.10475 5.04625C9.30542 5.12442 9.43783 5.26375 9.502 5.46425C9.566 5.65225 9.56208 5.84208 9.49025 6.03375C9.41825 6.22558 9.29075 6.37267 9.10775 6.475C8.08342 7.0275 7.26767 7.79958 6.6605 8.79125C6.0535 9.78308 5.75 10.8757 5.75 12.0692ZM18.25 11.9307C18.25 11.1494 18.1021 10.3898 17.8063 9.652C17.5106 8.91417 17.0495 8.23275 16.423 7.60775L15.7885 6.973V8.9615C15.7885 9.174 15.7166 9.35217 15.5727 9.496C15.4289 9.63967 15.2508 9.7115 15.0383 9.7115C14.8256 9.7115 14.6474 9.63967 14.5038 9.496C14.3603 9.35217 14.2885 9.174 14.2885 8.9615V5.23075C14.2885 4.97475 14.3751 4.76008 14.5483 4.58675C14.7216 4.41358 14.9363 4.327 15.1923 4.327H18.923C19.1355 4.327 19.3137 4.39892 19.4575 4.54275C19.6012 4.68658 19.673 4.86475 19.673 5.07725C19.673 5.28992 19.6012 5.468 19.4575 5.6115C19.3137 5.75517 19.1355 5.827 18.923 5.827H16.75L17.477 6.523C18.2668 7.31283 18.8432 8.17125 19.206 9.09825C19.5687 10.0251 19.75 10.9697 19.75 11.9323C19.75 13.4403 19.3644 14.8125 18.5932 16.049C17.8221 17.2855 16.7839 18.239 15.4788 18.9095C15.2968 19.0108 15.1054 19.024 14.9047 18.949C14.7041 18.874 14.5718 18.7362 14.5078 18.5357C14.4436 18.3477 14.4478 18.1577 14.5203 17.9655C14.5926 17.7732 14.7166 17.6263 14.8923 17.525C15.9166 16.9725 16.7323 16.2004 17.3395 15.2088C17.9465 14.2169 18.25 13.1242 18.25 11.9307Z",
    fill: "var(--fill-0, white)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSync);
export default __webpack_public_path__ + "static/media/icon-sync.738ab1504f59f730f73c67b7e82b70a8.svg";
export { ForwardRef as ReactComponent };